var NewsList = function () {

	this.init = function () {
		$('[data-component="news-list"] .row:not(:first-child)').slick({
			dots: false,
			slidesToShow: 3,
			infinite: false,
			arrows: false,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						dots: true
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						dots: true
					}
				}
			]
		});

		if (window.innerWidth > 767) {
			equalizer();
		}

		$(window).on('resize', function () {
			equalizer();
		})

		function equalizer() {
			var titleMaxHeight = 0;
			var textMaxHeight = 0;
			var imgMaxHeight = 0;
			if (window.innerWidth <= 767) {
				$("[data-component='card-news'].informations-above-title .card-title, [data-component='card-news'].informations-above-title .img-holder .img, [data-component='card-news'].informations-above-title .card-text").css('height', 'auto');

			} else {
				$("[data-component='card-news'].informations-above-title  .card-title").each(function () {
					$(this).css('height', 'auto');
					if ($(this).outerHeight() > titleMaxHeight) {
						titleMaxHeight = $(this).outerHeight();
					}
				});
				$("[data-component='card-news'].informations-above-title .card-title").outerHeight(titleMaxHeight);

				$("[data-component='card-news'].informations-above-title .card-text").each(function () {
					$(this).css('height', 'auto');
					if ($(this).outerHeight() > textMaxHeight) {
						textMaxHeight = $(this).outerHeight();
					}
				});
				$("[data-component='card-news'].informations-above-title .card-text").outerHeight(textMaxHeight);

				$("[data-component='card-news'].informations-above-title .img-holder .img").each(function () {
					$(this).css('height', 'auto');
					if ($(this).outerHeight() > imgMaxHeight) {
						imgMaxHeight = $(this).outerHeight();
					}
				});
				$("[data-component='card-news'].informations-above-title .img-holder .img").outerHeight(imgMaxHeight);
			}
		}
	}

	return this.init();
}
